import * as React from 'react';
import { TImprovedContentMarketing } from '../../../../shared/types/contentMarketing';
import { getConfig, getExperimentVariantFromConfig } from '../../../config';
import { Clickable } from '@fabric-ds/react';
import { useMemo } from 'react';
import { UNLEASH_FEATURE_NAMES } from '../../../../shared/unleash/feature-names';

type ContentMarketingTextContainerType = {
    smallText?: boolean;
    disableTextBalancer?: boolean;
    hideSponsor?: boolean;
    contentMarketing: TImprovedContentMarketing;
};

const TextContainer = ({
    contentMarketing,
    hideSponsor = false,
}: // smallText = false,
ContentMarketingTextContainerType) => {
    const { deviceType } = getConfig();
    const isMobile = deviceType === 'mobile';
    const title = contentMarketing.title.replace(/\\n/g, '<br/>');
    const cleanTitle = contentMarketing?.title.replace(/\\n/g, '');

    const stikkTitle = useMemo(() => {
        return isMobile
            ? contentMarketing?.text
            : contentMarketing?.textDesktop
            ? contentMarketing?.textDesktop
            : contentMarketing?.text;
    }, [isMobile, contentMarketing.text, contentMarketing.textDesktop]);

    const accessibilityId = `cm-title-${contentMarketing.id}`;

    const textExperiment = getExperimentVariantFromConfig(
        UNLEASH_FEATURE_NAMES.contentMarketingTextExperiment,
    ) as 'control' | 'challengerShadowTextButtonMid' | 'challengerButtonLeft';

    const renderSponsorData = (sponsorData) => (
        <div className={`text-gray-500 text-14 mb-4`}>
            <span>{sponsorData.name}</span>
        </div>
    );

    const renderStikkTitle = (stikkTitle) => (
        <div className={`mb-0 text-left text-14 sm:text-16 font-bold`}>
            {stikkTitle}
        </div>
    );

    const renderClickable = (href, cleanTitle, accessibilityId, title) => (
        <Clickable
            href={href}
            rel="noreferrer"
            target="_blank"
            title={cleanTitle}
            id={accessibilityId}
            className={
                'link link--dark sf-ad-link text-gray-700 hover:no-underline focus:no-underline focus-ring'
            }
        >
            <div className={`w-full text-left`} data-testid={'cm-title'}>
                {title}
            </div>
        </Clickable>
    );

    const showIntroductionText =
        textExperiment !== 'control' ||
        // Hack to show intro text on dredition preview
        (typeof window !== 'undefined' &&
            window.location.host.includes('schibsted.dredition.aptoma'));

    return (
        <div>
            {!hideSponsor &&
                Boolean(contentMarketing?.sponsorData?.name) &&
                renderSponsorData(contentMarketing.sponsorData)}
            {!!stikkTitle && renderStikkTitle(stikkTitle)}
            <h2
                className={`h3 sm:h2 font-normal text-left mb-0 whitespace-pre-wrap text-ellipsis no-underline`}
                id={accessibilityId}
            >
                {renderClickable(
                    contentMarketing?.href,
                    cleanTitle,
                    accessibilityId,
                    title,
                )}
                {showIntroductionText && contentMarketing?.introduction && (
                    <div>
                        <div className={'relative'}>
                            <p
                                className={`text-14 text-gray-600 ${
                                    textExperiment ===
                                    'challengerShadowTextButtonMid'
                                        ? 'content-marketing-desc-fadeout'
                                        : ''
                                }`}
                            >
                                {contentMarketing.introduction}
                            </p>
                        </div>
                        {contentMarketing?.ctaText && (
                            <div
                                className={
                                    'mt-10 inline-block px-16 py-8 rounded-8 border border-solid border-bluegray-300 text-blue-600 text-16'
                                }
                            >
                                {contentMarketing.ctaText}
                            </div>
                        )}
                    </div>
                )}
            </h2>
        </div>
    );
};

export default TextContainer;
